<template>
  <div class="license-form">
    <div class="columns">

      <div class="column">
        <div class="group">
          <label>{{$t('email')}}</label>
          <input type="text" v-model="value.email">
        </div>
        <div class="group">
          <label>{{$t('server')}}</label>
          <AjaxSelect
            v-model="value.server"
            :api="`/api/entity/server/select`"
            :map-fn="(s) => s.name"
            :allow-empty-search="true"
          />
        </div>
        <div class="group">
          <label>Branch name canonical</label>
          <input type="text" v-model="value.branchNameCanonical">
        </div>
        <div class="group">
          <label>Company name canonical</label>
          <input type="text" v-model="value.companyNameCanonical">
        </div>
      </div>

      <div class="column">

      </div>

    </div>
  </div>
</template>

<script>
import AjaxSelect from "@/components/tools/AjaxSelect";
export default {
  name: "LicenseForm",
  components: {AjaxSelect},
  props: {
    value: Object
  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>

</style>
